import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UigTermsConditionsDialogComponent } from './uig-terms-conditions-dialog.component';
import { ConsentManagementModule, IconModule, KeyboardFocusModule, SpinnerModule } from '@spartacus/storefront';
import { I18nModule } from '@spartacus/core';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    IconModule,
    SpinnerModule,
    KeyboardFocusModule
  ],
  declarations: [UigTermsConditionsDialogComponent],
  exports: [UigTermsConditionsDialogComponent]
})
export class UigTermsConditionsDialogModule { }
